// frontend/src/utils/crsUtils.js
import { BAD_VALUE, testValueToNameMap } from '../constants/crsFormOptions'; // Adjust path as needed

/**
 * Maps the raw form data state to the structure expected by the
 * calculateOfficialCRS function.
 * @param {object} formData - The raw form data from useCRSFormState.
 * @param {object} conditionals - The calculated conditional flags from useCRSConditionals.
 * @returns {object} - The data structured for the calculation function.
 */
export function mapFormDataToCalculationParams(formData, conditionals) {
  const { showSpouseFactors } = conditionals; // Destructure needed conditionals

  return {
    // Map marital status and spouse logic
    // Determine 'Single' status based on official script logic (A, C, D, F, G are treated as single for points)
    maritalStatus: ['A', 'C', 'D', 'F', 'G'].includes(formData.maritalStatus) ? 'Single' : (formData.maritalStatus === 'B' ? 'CommonLaw' : 'Married'),
    spouseOrPartnerIsPR: formData.spouseOrPartnerIsPR === 'B', // Map 'B' to true
    spouseOrPartnerWillAccompany: formData.spouseOrPartnerWillAccompany === 'B', // Map 'B' to true

    // Direct mapping for simple values
    age: formData.age,
    educationLevel: formData.educationLevel,
    studiedInCanada: formData.studiedInCanada === 'B',
    canadianEducationLevel: formData.studiedInCanada === 'B' ? formData.canadianEducationLevel : null,

    // Map language tests and scores
    firstLanguageTest: testValueToNameMap[formData.firstLanguageTest] || null,
    firstLanguageScores: formData.firstLanguageScores,
    hasSecondLanguageTest: formData.secondLanguageTest !== BAD_VALUE && formData.secondLanguageTest !== 'C', // Determine based on selection
    secondLanguageTest: formData.secondLanguageTest !== BAD_VALUE && formData.secondLanguageTest !== 'C' ? testValueToNameMap[formData.secondLanguageTest] : null,
    secondLanguageScores: formData.secondLanguageTest !== BAD_VALUE && formData.secondLanguageTest !== 'C' ? formData.secondLanguageScores : null,

    // Map work experience
    canadianWorkExperience: formData.canadianWorkExperience,
    foreignWorkExperience: formData.foreignWorkExperience,

    // Map additional factors
    hasCertificateOfQualification: formData.hasCertificateOfQualification === 'B',
    hasValidJobOffer: formData.hasValidJobOffer === 'B',
    jobOfferNocTeer: formData.hasValidJobOffer === 'B'
                      ? (formData.jobOfferNocTeer === 'A' ? '00' : (formData.jobOfferNocTeer === 'B' ? '0123' : null))
                      : null,
    hasProvincialNomination: formData.hasProvincialNomination === 'B',
    hasSiblingInCanada: formData.hasSiblingInCanada === 'B',

    // Map spouse factors (only if applicable)
    spouseEducationLevel: showSpouseFactors ? formData.spouseEducationLevel : null,
    spouseCanadianWorkExperience: showSpouseFactors ? formData.spouseCanadianWorkExperience : null,
    spouseLanguageTest: showSpouseFactors && formData.spouseLanguageTest !== 'E' ? testValueToNameMap[formData.spouseLanguageTest] : null, // Assuming 'E' was N/A
    spouseLanguageScores: showSpouseFactors && formData.spouseLanguageTest !== 'E' ? formData.spouseLanguageScores : null,
  };
}